module.exports = __webpack_public_path__ + "static/img/0bf30081dd17431c4fdfbd237c53743f.0bf3008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item/0bf30081dd17431c4fdfbd237c53743f.jpg
// module id = fN4m
// module chunks = 0